import React from 'react';

const TermsAndConditions: React.FC = () => {
  return (
    <div className="bg-gray-50 min-h-screen"> {/* A light background for the whole page */}
      {/* Hero Section for Title */}
      <div className="bg-blue-900 py-16 sm:py-24 text-white text-center">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight"> {/* Removed -mt-20 here, as it conflicts with main content negative margin */}
          Terms and Conditions
        </h1>
      </div>

      {/* Main Content Area - Card-like structure */}
      {/* Adjusted negative margin slightly to ensure good overlap and visibility on all screens */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12 -mt-14 sm:-mt-32 relative z-10 ">
        <div className="bg-white shadow-xl rounded-lg p-6 sm:p-8 md:p-12">
          <p className="text-gray-700 mb-8 text-base sm:text-lg leading-relaxed">
            Welcome to Nadezhda Ventures Pvt. Ltd. ("Company," "we," "our," or "us"). These Terms and Conditions (“Terms”) govern your use of the website{' '}
            <a href="https://www.nadezhda.in" className="text-blue-600 hover:text-blue-800 transition-colors duration-200 underline" target="_blank" rel="noopener noreferrer">
              https://www.nadezhda.in
            </a>{' '}
            and all services we provide. This document forms a binding contract between you and us. Your continued access or use of our website and services signifies your agreement to these Terms. If you do not agree with any part of these Terms, please do not use our website or services.
          </p>

          {/* --- Section 1: Acceptance of Terms --- */}
          <div className="border-t border-gray-200 pt-8 mt-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
              1. Acceptance of Terms
            </h2>
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              By accessing, navigating, or utilizing this website and/or any service offered through it, you are legally bound by these Terms. We may update or modify these Terms periodically, and your continued use of the site after such changes constitutes your acceptance of the revised Terms. We encourage you to review them regularly.
            </p>
          </div>

          {/* --- Section 2: Eligibility --- */}
          <div className="border-t border-gray-200 pt-8 mt-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
              2. Eligibility
            </h2>
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              To use our services, you must be at least <strong className="font-semibold">18 years old</strong> or of legal age in your jurisdiction. By accessing this website, you affirm that you possess the full legal power, authority, and capacity to enter into and comply with these Terms.
            </p>
          </div>

          {/* --- Section 3: Services Offered --- */}
          <div className="border-t border-gray-200 pt-8 mt-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
              3. Services Offered
            </h2>
            <p className="text-gray-700 mb-4 leading-relaxed text-base sm:text-lg">
              Nadezhda Ventures Pvt. Ltd. specializes in providing comprehensive <strong className="font-semibold">business support services, virtual assistant services, backend operations, and consultancy services</strong> across various industries. The specific terms for our services are typically customized to meet individual client needs and are formalized through a separate agreement or proposal.
            </p>
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              Please note that we reserve the right to modify, suspend, or discontinue any or all aspects of our services at any time, with or without prior notice.
            </p>
          </div>

          {/* --- Section 4: User Conduct --- */}
          <div className="border-t border-gray-200 pt-8 mt-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
              4. User Conduct
            </h2>
            <p className="text-gray-700 mb-6 leading-relaxed text-base sm:text-lg">
              By using our website and services, you explicitly agree not to engage in any of the following prohibited activities:
            </p>
            <ul className="list-disc list-inside text-gray-700 ml-4 sm:ml-6 space-y-2 text-base sm:text-lg">
              <li>Breaching any applicable local, national, or international laws or regulations.</li>
              <li>Violating any <strong className="font-semibold">intellectual property rights</strong> belonging to us or any third party.</li>
              <li>Submitting false, inaccurate, or misleading information.</li>
              <li>Interfering with or disrupting the proper operation, security, or integrity of our website.</li>
              <li>Attempting to access our website or underlying systems through any unauthorized means, other than the interfaces we officially provide.</li>
            </ul>
          </div>

          {/* --- Section 5: Payments and Refunds --- */}
          <div className="border-t border-gray-200 pt-8 mt-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
              5. Payments and Refunds
            </h2>
            <ul className="list-disc list-inside text-gray-700 ml-4 sm:ml-6 space-y-2 text-base sm:text-lg">
              <li>All payments deposited into Nadezhda Ventures Pvt. Ltd. are as per the conditions stated in the invoice or client agreement.</li>
              <li>Charges are due and payable at the end of each agreed upon period.</li>
              <li>Refunds can only be initiated within 7 business days from the date of registration. The refunded amount will be credited to the same account/card/UPI/wallet within 5–7 business days.</li>
              <li>Service will not be activated prior to payment unless otherwise noted.</li>
            </ul>
          </div>

          {/* --- Section 6: Intellectual Property --- */}
          <div className="border-t border-gray-200 pt-8 mt-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
              6. Intellectual Property
            </h2>
            <p className="text-gray-700 mb-4 leading-relaxed text-base sm:text-lg">
              <strong className="font-semibold">Ownership of Contents</strong> All content, branding, design elements and materials on this website are proprietary to or licensed by Nadezhda Ventures Pvt. Ltd. Users cannot copy, reproduce, distribute, sell, exploit, or use for any commercial purposes, any portion of the Service, Site or the Company Materials without our written consent.
            </p>
          </div>

          {/* --- Section 7: Third-Party Services --- */}
          <div className="border-t border-gray-200 pt-8 mt-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
              7. Third-Party Services
            </h2>
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              Our Service may contain links to third-party web sites or services that are not owned or controlled by Us. We are not responsible for the content, practices or terms of any third-party platforms.
            </p>
          </div>

          {/* --- Section 8: Limitation of Liability --- */}
          <div className="border-t border-gray-200 pt-8 mt-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
              8. Limitation of Liability
            </h2>
            <p className="text-gray-700 mb-4 leading-relaxed text-base sm:text-lg">
              To the fullest extent permitted by applicable law, Nadezhda Ventures Pvt. Ltd is not liable for indirect, direct or incidental damages due to the following reasons:
            </p>
            <ul className="list-disc list-inside text-gray-700 ml-4 sm:ml-6 space-y-2 text-base sm:text-lg">
              <li>Use the website or services; and Inability to use the website or services.</li>
              <li>Unauthorised access/alteration of your data.</li>
              <li>Statements or actions that any third party makes on the site.</li>
            </ul>
            <p className="text-gray-700 mt-4 leading-relaxed text-base sm:text-lg">
              You hereby agree to access and use the service at your own risk.
            </p>
          </div>

          {/* --- Section 9: Disclaimer of Warranties --- */}
          <div className="border-t border-gray-200 pt-8 mt-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
              9. Disclaimer of Warranties
            </h2>
            <p className="text-gray-700 mb-4 leading-relaxed text-base sm:text-lg">
              The website is made available to you on your acceptance of these Terms of Service and our Privacy Policy. We do not guarantee that our site, or any content on it, will always be available or be uninterrupted.
            </p>
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              <strong className="font-semibold">DISCLAIMER OF WARRANTIES</strong> Nadezhda Ventures Pvt. Ltd. specifically disclaims all warranties of any kind, whether expressed or implied, including but not limited to: implied warranties of merchantability, fitness for a purpose, and non-infringement.
            </p>
          </div>

          {/* --- Section 10: Termination --- */}
          <div className="border-t border-gray-200 pt-8 mt-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
              10. Termination
            </h2>
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              We can suspend or stop providing our site or services to you if we think that you have violated these Terms or the law.
            </p>
          </div>

          {/* --- Section 11: Governing Law and Jurisdiction --- */}
          <div className="border-t border-gray-200 pt-8 mt-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
              11. Governing Law and Jurisdiction
            </h2>
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              The provisions of these Terms will be governed by and construed in accordance with the laws of India. All disputes arising out of or in connection with the these Terms shall be exclusively referred to the courts in Delhi, India.
            </p>
          </div>

          {/* --- Section 12: Contact Us --- */}
          <div className="border-t border-gray-200 pt-8 mt-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
              12. Contact Us
            </h2>
            <p className="text-gray-700 mb-2 leading-relaxed text-base sm:text-lg">
              If you have any questions about these Terms of Service, you may contact us at:
            </p>
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              <strong className="font-semibold">Nadezhda Ventures Pvt. Ltd.</strong>
            </p>
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              <strong className="font-semibold">Email:</strong>{' '}
              <a href="mailto:contact@nadezhda.in" className="text-blue-600 hover:text-blue-800 transition-colors duration-200 underline">
                contact@nadezhda.in
              </a>
            </p>
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              <strong className="font-semibold">Website:</strong>{' '}
              <a href="https://www.nadezhda.in" className="text-blue-600 hover:text-blue-800 transition-colors duration-200 underline" target="_blank" rel="noopener noreferrer">
                https://www.nadezhda.in
              </a>
            </p>
          </div>

          <p className="text-center text-gray-600 mt-10 text-sm sm:text-base">
            Last updated: July 30, 2025
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;